import { ComponentProps, FC } from 'react';

import { motion } from 'framer-motion';

import { Button } from '@ui-furniture/elements';
import { movement, time } from '@ui-furniture/lib/utils';
import { useUp, x } from '@ui-furniture/style';

const OptionsGroupAnimateContainer = (props: any) => (
  <motion.div
    {...props}
    initial='hidden'
    animate='visible'
    exit='hidden'
    variants={{
      hidden: {
        transition: {
          staggerChildren: time.md,
          staggerDirection: 'reverse',
        },
      },
    }}
    transition={{
      staggerChildren: time.md,
    }}
  />
);

export const ButtonGrid: FC<{
  options: Array<
    {
      label: string;
      onClick: () => void;
    } & Omit<ComponentProps<typeof Button>, 'type'>
  >;
}> = ({ options }) => {
  const isTabletOrBigger = useUp('tablet');
  const onlyOneOption = options.length === 1;
  const gridTemplateColumns =
    onlyOneOption || !isTabletOrBigger ? '1fr' : '1fr 1fr';

  return (
    <x.div
      as={OptionsGroupAnimateContainer}
      display='grid'
      gap='sm'
      alignItems='center'
      gridTemplateColumns={gridTemplateColumns}
      gridAutoRows='auto'
    >
      {options.map(({ label, onClick, ...rest }) => (
        <motion.div
          key={label}
          style={{ height: '100%' }}
          variants={{
            hidden: {
              y: movement.sm,
              opacity: 0,
            },
            visible: {
              y: 0,
              opacity: 1,
            },
          }}
        >
          <Button
            type='button'
            variant='outline'
            version='secondary'
            w='100%'
            h='100%'
            onClick={onClick}
            {...rest}
          >
            {label}
          </Button>
        </motion.div>
      ))}
    </x.div>
  );
};
